import { Link } from 'react-router-dom';
import type { categories as CategoriesType } from '@/mocks/categories';

interface CategoryTabsProps {
  categories: typeof CategoriesType;
  activeId?: string;
}

export default function CategoryTabs({ categories, activeId }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
      <Link
        to="/category/all"
        className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
          !activeId || activeId === 'all'
            ? 'bg-primary-500 text-background-50'
            : 'bg-background-100 text-foreground-600 hover:bg-background-200'
        }`}
      >
        全部分类
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.id}
          to={`/category/${cat.id}`}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
            activeId === cat.id
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          <i className={`${cat.icon} text-xs`}></i>
          {cat.name}
        </Link>
      ))}
    </div>
  );
}